import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { enableProdMode } from "@angular/core";
import { environment } from "./environments/environment";
import "zone.js";
import { AppModule } from "@app/app.module";

if (environment.production) {
    enableProdMode();
}

// VS-1692: wait for the runtime brand bootstrap (index.html) to apply --brand-*
// before Angular renders. Resolves immediately if the resolver is absent (tests)
// or errored — the app then boots with the static vSaúde defaults.
const brandReady: Promise<unknown> = Promise.resolve((window as unknown as { __brandReady?: Promise<unknown> }).__brandReady).catch(
    () => undefined,
);

brandReady.then(() => platformBrowserDynamic().bootstrapModule(AppModule));
